import { useQuery } from '@tanstack/react-query';

import http from '@frontend/api/http';
import { OPAL_URL } from '@frontend/envConfig';
import { CompanionRule } from '@frontend/types';
import { PaginatedResponse } from '@frontend/types/pagination';

type UseAppCompanionRuleListParams = {
  agentId: string;
  page?: number;
  pageSize?: number;
  searchQuery?: string;
};

export function useAppCompanionRuleList({
  agentId,
  page = 1,
  pageSize = 20,
  searchQuery = '',
}: UseAppCompanionRuleListParams) {
  return useQuery({
    queryKey: ['opal:app-companion', 'rules', agentId, page, pageSize, searchQuery],
    queryFn: async (): Promise<PaginatedResponse<CompanionRule>> => {
      const res = await http.get<PaginatedResponse<CompanionRule>>(
        `${OPAL_URL}/app-companion/api/v2/agents/${agentId}/rules`,
        {
          params: {
            page,
            page_size: pageSize,
            search: searchQuery || undefined,
          },
        }
      );
      return res.data;
    },
    enabled: !!agentId,
  });
}
